interface ToggleRowProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (value: boolean) => void;
}

export function ToggleRow({ id, label, checked, onChange }: ToggleRowProps) {
  return (
    <label
      htmlFor={id}
      className="flex cursor-pointer items-center justify-between gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3"
    >
      <span className="text-sm font-medium text-ink">{label}</span>
      <span className="relative inline-block">
        <input
          id={id}
          type="checkbox"
          className="sr-only"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span
          className={`block h-6 w-11 rounded-full transition-colors ${
            checked ? "bg-ember" : "bg-gray-200"
          }`}
        />
        <span
          className={`absolute top-0.5 left-0.5 block h-5 w-5 rounded-full bg-white shadow transition-transform ${
            checked ? "translate-x-5" : "translate-x-0"
          }`}
        />
      </span>
    </label>
  );
}
